export const SETTINGS_FETCH_START = 'SETTINGS_FETCH_START';
export const SETTINGS_FETCH_SUCCESS = 'SETTINGS_FETCH_SUCCESS';
export const SETTINGS_FETCH_FAIL = 'SETTINGS_FETCH_FAIL';

export const SETTINGS_SAVE_START = 'SETTINGS_SAVE_START';
export const SETTINGS_SAVE_SUCCESS = 'SETTINGS_SAVE_SUCCESS';
export const SETTINGS_SAVE_FAIL = 'SETTINGS_SAVE_FAIL';

export const SETTINGS_SYNC_ENV_START = 'SETTINGS_SYNC_ENV_START';
export const SETTINGS_SYNC_ENV_SUCCESS = 'SETTINGS_SYNC_ENV_SUCCESS';
export const SETTINGS_SYNC_ENV_FAIL = 'SETTINGS_SYNC_ENV_FAIL';
